import React from 'react';
import {
  VisaLogo,
  MasterCardLogo,
  DiscoverLogo,
  AmexLogo,
  GenericLogo,
  DinersLogo,
  JCBLogo,
} from './CardLogoSet';

export type CardLogoProps = {
  cardTypeName?: string;
  className?: string;
};

const renderLogo = (cardTypeName?: string): React.ReactNode => {
  const normalizedCardName = cardTypeName?.toLowerCase().replace(/\s/gm, '');
  switch (normalizedCardName) {
    case 'visa':
      return <VisaLogo />;
    case 'mastercard':
      return <MasterCardLogo />;
    case 'discover':
      return <DiscoverLogo />;
    case 'amex':
    case 'americanexpress':
      return <AmexLogo />;
    case 'diners':
    case 'dinersclub':
      return <DinersLogo />;
    case 'jcb':
      return <JCBLogo />;
    default:
      return <GenericLogo />;
  }
};

const CardLogo: React.FC<CardLogoProps> = ({
  cardTypeName,
  className = '',
}: CardLogoProps) => {
  return (
    <div className={`${className} pointer-events-none`}>
      {renderLogo(cardTypeName)}
    </div>
  );
};

export default CardLogo;
